"use client";

import React from "react";
import { MapPin } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const suburbs = ["Gorokan", "Toukley", "Norah Head", "Gwandalan", "Budgewoi", "Lake Haven", "Charmhaven", "Surrounding Suburbs"];
export default function ServiceAreas() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: mapRef,
    isVisible: isMapVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}